module.exports = __webpack_public_path__ + "img/20_64.b1fff4e8.png";